module.exports = __webpack_public_path__ + "static/media/small-hearts.9efc6826.svg";